module.exports = __webpack_public_path__ + "static/media/stampex_logo.59efb978.jpeg";